/* eslint-disable @typescript-eslint/naming-convention */

export class Message {
  targetId: number;
  senderId: number;
  text: string;
  messageType: MessageType;
}

export enum MessageType {
  SYSTEM,
  TO_STUDENT,
  TO_STAFF,
  SEEN,
  TO_ALL
}
